module.exports = __webpack_public_path__ + "img/GHY.85330a44.png";